import React from "react";
import { TextField, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  largeAvatar: {
    width: "90px",
    height: "90px",
  },
  error: {
    marginLeft: 2,
    color: "#d73131",
    fontWeight: 600,
  },
  textfield: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      "& fieldset": {
        borderColor: "rgb(0 0 0 / 14%)",
      },
      "&:hover fieldset": {
        borderColor: "rgb(0 0 0 / 40%)",
      },
    },
  },
}));

export default function Input(props) {
  const {
    name,
    label,
    onChange,
    variant = "outlined",
    acceptedCharacters = null,
    ...other
  } = props;
  const classes = useStyles();

  const handleChange = (event) => {
    const { value } = event.target;
   
    if (acceptedCharacters) {
      const isValid = [...value].every((char) =>
        acceptedCharacters.includes(char)
      );
      if (!isValid) {
       
        return;
      }
    }

    onChange(event);
  };

  return (
    <TextField
      variant={variant}
      label={label}
      onChange={handleChange}
      {...other}
      className={other.className ? other.className : classes.textfield}
    />
  );
}
